module.exports = __webpack_public_path__ + "media/mixkit-beautiful-dream-493.eca45497.mp3";